import { createMuiTheme } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import { lighten } from '@material-ui/core/styles';

import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: getColorTheme('default'), // ???
      main: getColorTheme('default'), // Links on login page
      dark: '#273653', // ???
      contrastText: '#fafafa',
    },
    secondary: {
      light: '#526080',
      main: '#273653', // ???
      dark: '#00102a',
      contrastText: '#fafafa',
    },
    error: {
      light: '#f55a4e',
      main: '#e53935',
      dark: '#f44336',
      contrastText: '#fafafa',
    },
    success: {
      light: green[300],
      main: green[600],
      dark: green[900],
      contrastText: '#fafafa',
    },
  },
  overrides: {
    MuiLinearProgress: {
      colorPrimary: {
        backgroundColor: lighten(getColorTheme('loadingBarBackground'), 0.5), // Loading bar background color
      },
      barColorPrimary: {
        backgroundColor: getColorTheme('loadingBar'), // Loading bar color
      },
    },
    MuiSwitch: {
      colorPrimary: {
        '&$checked + $track': {
          backgroundColor: getColorTheme('multiSwitchBackground'), // Slide button background
        },
      },
      colorSecondary: {
        '&$checked + $track': {
          backgroundColor: getColorTheme('multiSwitchBackground'), // Slide button background
        },
        '&$checked': {
          color: getColorTheme('multiSwitchHead') + ' !important', // Slide button head color
        },
      },
    },
  },
});
